if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.bindHoverPreload();
      }

      // Same as ModalDialog.hide() in global.js, except focus goes back to
      // the opener with preventScroll. The plain focus() there was scrolling
      // the page to the image on close.
      hide() {
        document.body.classList.remove('overflow-hidden');
        document.body.dispatchEvent(new CustomEvent('modalClosed'));
        this.removeAttribute('open');
        removeTrapFocus();
        if (this.openedBy) this.openedBy.focus({ preventScroll: true });
        window.pauseAllMedia();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        this.revealWhenLoaded(activeMedia);
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }

      // If the large image isn't loaded yet, keep it invisible and hold the
      // hlModalFadeIn animation. Once it's loaded and decoded, clearing the
      // inline styles restarts the animation, so it fades in fully drawn.
      revealWhenLoaded(media) {
        if (media.nodeName !== 'IMG') return;
        media.loading = 'eager';
        if (media.complete && media.naturalWidth) return;

        media.style.animation = 'none';
        media.style.opacity = '0';

        const reveal = () => {
          media.style.animation = '';
          media.style.opacity = '';
        };

        media.addEventListener(
          'load',
          () => {
            const decoded = media.decode ? media.decode().catch(() => {}) : Promise.resolve();
            decoded.then(reveal);
          },
          { once: true }
        );
        media.addEventListener('error', reveal, { once: true });
      }

      // Desktop: start loading the large image on hover, so it's usually
      // ready by the time the click opens the viewer.
      bindHoverPreload() {
        if (!window.matchMedia('(hover: hover)').matches) return;
        document.addEventListener('pointerover', (event) => {
          const opener = event.target.closest('.product__media-toggle[data-media-id]');
          if (!opener) return;
          const img = this.querySelector(`img[data-media-id="${opener.getAttribute('data-media-id')}"]`);
          if (img && img.loading !== 'eager') img.loading = 'eager';
        });
      }
    }
  );
}
